<template>
	<div
		class="h-full rounded-xl border border-neutral border-solid bg-neutral shadow-lg dark:border-neutral-dark dark:bg-primary-dark"
	>
		<div class="flex flex-row justify-between items-baseline">
			<p v-if="props.cardTitle" class="w-full text-xl font-bold mx-7.5 mt-6.5 "
				:class="{ 'border-b border-neutral pb-6' : titleDividerLine }">
				{{ props.cardTitle }}
			</p>
			<p
				v-if="props.actionText"
				class="font-bold underline cursor-pointer mr-7.5 mt-6.5"
				@click="$emit('actionClicked')"
			>
				{{ props.actionText }}
			</p>
		</div>
		<div class="h-full" :class="props.innerPadding">
			<slot></slot>
		</div>
	</div>
</template>

<script setup lang="js">
const props = defineProps({
	innerPadding: { type: String, default: 'p-8' },
	titleDividerLine: { type: Boolean, default: false },
	cardTitle: { type: String },
	actionText: { type: String }
})
</script>